
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/contexts/AuthContext";
import { Command, CommandEmpty, CommandGroup, CommandItem, CommandList } from "@/components/ui/command";

interface StartupMentionProps {
  searchTerm: string;
  onSelect: (startup: { id: string; name: string }) => void;
  isVisible: boolean;
}

export const StartupMention = ({ searchTerm, onSelect, isVisible }: StartupMentionProps) => {
  const { user } = useAuth();

  const { data: startups, isLoading } = useQuery({
    queryKey: ["startups-mention", searchTerm],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("startups")
        .select("id, name, user_id")
        .ilike("name", `%${searchTerm}%`)
        .limit(10);

      if (error) {
        console.error("Error fetching startups for mention:", error);
        throw error;
      }

      return data || [];
    },
    enabled: isVisible && !!searchTerm && searchTerm.length > 0
  });

  if (!isVisible) return null;

  return (
    <div className="absolute bottom-full left-0 w-full mb-1 rounded-md border border-flux-cyan/20 bg-black/90 shadow-lg">
      <Command>
        <CommandList>
          <CommandEmpty>No startups found</CommandEmpty>
          <CommandGroup>
            {isLoading ? (
              <div className="p-2 text-sm text-gray-400">Loading startups...</div>
            ) : (
              startups?.map((startup) => (
                <CommandItem
                  key={startup.id}
                  onSelect={() => onSelect(startup)}
                  className="flex items-center justify-between gap-2 cursor-pointer py-2"
                >
                  <div className="flex items-center gap-2">
                    <span className="text-flux-cyan">$</span>
                    <span className="text-white">{startup.name}</span>
                  </div>
                  {startup.user_id === user?.id && (
                    <span className="text-xs bg-flux-cyan/20 text-flux-cyan px-2 py-0.5 rounded">
                      my startup
                    </span>
                  )}
                </CommandItem>
              ))
            )}
          </CommandGroup>
        </CommandList>
      </Command>
    </div>
  );
};
